import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

/**
 * 应用程序入口点
 * 使用React 18的并发特性进行渲染
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
      </StrictMode>
) 